import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TemplateService {
    /**
     * Get All Templates
     * Get the full list of all templates. These are jobs that were created
     * by the user with the username TEMPLATE_USERNAME.
     *
     * Args:
     * repo (Repository, optional): Repository instance. Injected by fastapi.
     *
     * Returns:
     * models.FullJobsList: All template jobs in the DB.
     * @returns FullJobsList Successful Response
     * @throws ApiError
     */
    static getAllTemplates() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/template',
        });
    }
    /**
     * Instantiate Template
     * Create an instance of a template by copying it for a new user.
     *
     * Args:
     * template_job (models.Job, optional): The template job, owned by
     * TEMPLATE_USERNAME. This is dependency-injected by FastAPI based on the
     * value of "template_id".
     *
     * user (models.User, optional): The new user to copy the job to.
     * Dependency-injected by FastAPI.
     *
     * repo (Repository, optional): The repository storing the jobs.
     * Dependency-injected.
     * @param templateId
     * @returns JobLite Successful Response
     * @throws ApiError
     */
    static instantiateTemplate(templateId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/template/{template_id}/instantiate',
            path: {
                'template_id': templateId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
